import client from './client';

const SdAnalytics = {
  getAnalytics(anketId) {
    return client.get(`/ankets/${anketId}/sd_analytics`);
  },
  getReport(anketId, debtorId) {
    return client.get(`/ankets/${anketId}/sd_analytics/${debtorId}`);
  },
};

export default SdAnalytics;
